import React, { Component } from 'react';
import PropTypes from 'prop-types';

import DangerousHTML from 'react-dangerous-html';


// /**
//  * Html
//  */
// const Html = ({
//   htmlText,
// }) => (
//   <div
//     className="Html"
//     dangerouslySetInnerHTML={{__html: (htmlText !== null) ? htmlText: ''}}
//   />
// );
// Html.propTypes = {
//   htmlText: PropTypes.string,
// };
// Html.defaultProps = {
//   htmlText: null,
// };
// export default Html;

export default class Html extends Component {
  static propTypes = {
    htmlText: PropTypes.string,
    inFeatureCategoriesHorizontal: PropTypes.bool,
  };
  static defaultProps = {
    htmlText: null,
    inFeatureCategoriesHorizontal: false,
  };

  constructor(props) {
    super(props);
    // this.state = {
    //   firstStyle: props.inFeatureCategoriesHorizontal ? { opacity: 0, float: 'left', } : null,
    // };
    this.refsContent = null;
  }
  // componentDidMount() {
  //   const { inFeatureCategoriesHorizontal } = this.props;
  //   if (inFeatureCategoriesHorizontal) {
  //     this.setState({ firstStyle: null });
  //   }
  // }
  // render() {
  //   const {
  //     htmlText,
  //   } = this.props;
  //   return (
  //     <div
  //       className="Html"
  //       dangerouslySetInnerHTML={{__html: (htmlText !== null) ? htmlText: ''}}
  //       ref={(component) => (this.refsContent = component)}
  //     />
  //   )
  // }
  
  render() {
    let {
      htmlText,
    } = this.props;
    
    htmlText = htmlText.replace(new RegExp('&lt;', 'g'), '<');
    htmlText = htmlText.replace(new RegExp('&gt;', 'g'), '>');
    
    return (
      <div
        className="Html"
        ref={(component) => (this.refsContent = component)}
      >
        <DangerousHTML html={(htmlText !== null) ? htmlText: ''} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/html/index.jsx